import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { DatePickerModule } from 'primeng/datepicker';
import { CheckboxModule } from 'primeng/checkbox';
import { PopoverModule } from 'primeng/popover';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { MultiSelectModule } from 'primeng/multiselect';

import { MessageModule } from 'primeng/message';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { TagModule } from 'primeng/tag';
import { CommonModule, DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  Input,
} from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';
import {
  AbstractControl,
  FormArray,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule, Routes } from '@angular/router';
import { AuthguardService, RouteStateService, TenantResolverService, availabilityOverlapsWithUnavailabilityValidator, endNotBeforeStart, startEndTimeRequired, timeSlotsValidator, unavailabilityOverlapsWithAvailabilityValidator } from '@fitness-force/shared';
import { StyleClassModule } from 'primeng/styleclass';
import { InputTextModule } from 'primeng/inputtext';
import { Store } from '@ngrx/store';
import {
  StaffService,
  TimeconversionService,
  ToastMessageService,
} from '@fitness-force/api';
import { StaffAvailabilityService } from '../../services/staff-availability.service';
import { BehaviorSubject, Observable, forkJoin } from 'rxjs';
import { Status, Tenant_Access } from '@fitness-force/enum';
import {
  APPOINTMENT_TYPE_STATE,
  TENANTS_INFO,
} from 'apps/ff-frontend/src/app/state/app.state';
import {
  AppointmentType,
  STAFF_MODEL,
  TENANTSINTERFACE,
} from '@fitness-force/models';
import {
  AppointmentCatagory,
  CreateStaffAvaialbilityConfigRequest,
  Interval,
  StafAvailabilityConfig,
  StattAppointmentTypeLink,
  TypeDate,
  TypeWeekday,
} from '../../models/staff-availability-config';
import { AvatarModule } from 'primeng/avatar';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { ErrorMsgComponent } from '@fitness-force/errors';
import { BreadcrumbComponent } from '@fitness-force/common/breadcrumb';


@Component({
  selector: 'staff-availability',
  templateUrl: './staff-availability.component.html',
  styleUrls: ['./staff-availability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SkeletonModule,
    TagModule,
    SelectModule,
    ButtonModule,
    MessageModule,
    MultiSelectModule,
    RadioButtonModule,
    ToggleSwitchModule,
    PopoverModule,
    CheckboxModule,
    DatePickerModule,
    DialogModule,
    StyleClassModule,
    InputTextModule,
    AvatarModule,
    ShortNamePipe,
    DateTimeFormatPipe,
    ErrorMsgComponent,
    BreadcrumbComponent,
    TranslateModule,
    RouterModule
  ]
})
export class StaffAvailabilityComponent implements OnInit {
  @Input('activeStaffId') activeStaffId: number = 0;
  staffId: number = 0;
  getAccessTenantList$: Observable<any> = new Observable();
  tenantAccess: Tenant_Access[] = [];
  tenantId = 0;
  tenant!: any;

  staffAvailabilityConfig$ = new BehaviorSubject<StafAvailabilityConfig[]>(
    [] as StafAvailabilityConfig[]
  );
  staffAppointmentTypeLink$ = new BehaviorSubject<StattAppointmentTypeLink[]>(
    [] as StattAppointmentTypeLink[]
  );
  staffDetails$ = new BehaviorSubject<STAFF_MODEL>({} as STAFF_MODEL);
  staffApointmentLink$ = new BehaviorSubject<any[]>([] as any[]);
  appointmentCategories: AppointmentType[]=[];
  showSkeleton$ = new BehaviorSubject(true);

  staffAvailabilityConfigForm: UntypedFormGroup = {} as UntypedFormGroup;
  staffAvailabilityConfigDatesForm: UntypedFormGroup = {} as UntypedFormGroup;
  checkBoxForm: UntypedFormGroup = {} as UntypedFormGroup;
  selectedDate:any;

  WeekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  selectedDay: any;
  exceptionDatesAvailable: any = {};
  exceptionDatesUnAvailable: any = {};
  dynamicArray: ShowHideControl[] = [];
  selectedDayTimeSlot: { starttime: string; endtime: string } | undefined;
  currentIndex: number = 0;
  repeatsRadio: string = 'On-going';
  sunday: boolean = false;
  monday: boolean = true;
  tuesday: boolean = false;
  wednesday: boolean = false;
  thursday: boolean = false;
  friday: boolean = false;
  saturday: boolean = false;
  dateOverride: boolean = false;
  dateSelected: boolean = false;
  selectedDates = new Array();
  selectedConfigData:StafAvailabilityConfig = {} as StafAvailabilityConfig;
  singleDateEdit:boolean=false;
  ongoingDateSelected: boolean = false;
  specificDateRange: boolean = false;
  specificDateRangeSelected: boolean = false;
  onGoingDate: boolean = false;
  selectedSchedule: { name: string } | undefined;
  schedules: any[];
  exception_dates_data: TypeDate[]=[];
  selectedDateIndex:number=0;
  newSchedule:boolean=true;
  isSubmitting:boolean=false;
  createscheduleGroupId:number=0;



  constructor(
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private store: Store,
    public translate: TranslateService,
    private cd: ChangeDetectorRef,
    private staffAvailabilityService: StaffAvailabilityService,
    private toastMessageService: ToastMessageService,
    private staffService: StaffService,
    private datePipe: DatePipe,
    private timeService:TimeconversionService,
    private routeStateService: RouteStateService,
    private router: Router
  ) {

    this.staffAvailabilityConfigForm = this.fb.group({
      staff_availability_config: new UntypedFormControl('', []),
      name: new UntypedFormControl('', [Validators.required]),
      appointment_catagories: new UntypedFormControl('', []),
      schedule_type: new UntypedFormControl('', [Validators.required]),
      start_date: new UntypedFormControl('', [Validators.required]),
      end_date: new UntypedFormControl('', []),
      type_weekday: new UntypedFormControl('', []),
      type_date: new UntypedFormControl('', []),
      schedule_date_range: new UntypedFormControl('', []),
      ongoing_date: new UntypedFormControl('', []),
    });

    this.staffAvailabilityConfigDatesForm = this.fb.group({
      exception_dates: new UntypedFormControl([], []),
    });

    this.WeekDays.forEach((day) => {
      this.staffAvailabilityConfigForm.addControl(
        'selectedDay_' + day,
        new UntypedFormControl(false)
       );
       });

       this.checkBoxForm = this.fb.group({
        Sunday: new UntypedFormControl(false),
        Monday: new UntypedFormControl(false),
        Tuesday: new UntypedFormControl(false),
        Wednesday: new UntypedFormControl(false),
        Thursday: new UntypedFormControl(false),
        Friday: new UntypedFormControl(false),
        Saturday: new UntypedFormControl(false),
      });

      this.schedules = [
        { name: "On-going", value:'ongoing', key:"ONGOING" },
        { name: "Specific date range",value:'specificdaterange' ,key:"SPECIFICDATERANGE" },
      ];
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.showSkeleton$.next(true);
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantAccess = tenant.accessed_tenant.map((tObj) => ({
        id: tObj.id,
        name_primary_language: tObj.name_primary_language,
        name_secondary_language: tObj.name_secondary_language,
      })) as Tenant_Access[];

      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.tenant = tenant.selected_tenant;
        this.SetOnLoadData();
      }
    });
  }

  SetOnLoadData(): void {
    this.route.params.subscribe((params) => {
      if (params['id'] != undefined && parseInt(params['id']) > 0) {
        this.staffId = parseInt(params['id']);
        this.GetAppointmentTypes();
        this.GetAllData();
      }
      else if(this.activeStaffId > 0)
      {
        this.staffId= this.activeStaffId;
        this.GetAppointmentTypes();
        this.GetAllData();
      }
      else{
        this.showSkeleton$.next(false);
        this.toastMessageService.showErrorMessage("Staff not found");
        this.cd.detectChanges
      }
    });
  }

  GetAllData() {
    const staffDetails$ = forkJoin([
      this.staffService.GetStaffById(this.staffId),
      this.staffAvailabilityService.GetStaffAvailability(
        this.tenantId,
        this.staffId
      ),
      this.staffAvailabilityService.GetStaffAppointmentTypeLink(
        this.tenantId,
        this.staffId
      ),
    ]);

    staffDetails$.subscribe({
      next: (response: any) => {
        this.staffDetails$.next(response[0]);
        this.staffAvailabilityConfig$.next(
          response[1].items.length > 0
            ? (response[1].items as StafAvailabilityConfig[])
            : []
        );
        this.staffAppointmentTypeLink$.next(
          response[2].items.length > 0
            ? (response[2].items as StattAppointmentTypeLink[])
            : []
        );
        if (this.staffAvailabilityConfig$.value.length > 0) {
          if(this.createscheduleGroupId > 0)
            this.selectedConfigData = this.staffAvailabilityConfig$.value.find(o => o.group_id == this.createscheduleGroupId)!;
          else this.selectedConfigData = this.staffAvailabilityConfig$.value[0];
          this.exception_dates_data =this.selectedConfigData.type_date;
          this.newSchedule=false;
          this.createDynamicFormFields(this.selectedConfigData);
        }
        else{
          this.newSchedule=true;
          this.createDynamicFormFields(this.selectedConfigData);
        }

        if(this.staffAppointmentTypeLink$.value.length > 0)
        {
          this.appointmentCategories = this.appointmentCategories.filter((o:any) => this.staffAppointmentTypeLink$.value.find(appt => o.id == appt.appointment_type_id));
          let appointmentType : AppointmentType ={} as AppointmentType;
          appointmentType.id=0;
          appointmentType.name_primary_language= "Sales tour";
          appointmentType.name_secondary_language= "Sales tour";
          this.appointmentCategories.push(appointmentType);
        }
        else{
          this.appointmentCategories = [];
          let appointmentType : AppointmentType ={} as AppointmentType;
          appointmentType.id=0;
          appointmentType.name_primary_language= "Sales tour";
          appointmentType.name_secondary_language= "Sales tour";
          this.appointmentCategories.push(appointmentType);
        }

        this.showSkeleton$.next(false);
        this.cd.detectChanges();
      },
      error: (error: any) => {
        this.staffAvailabilityConfig$.next([]);
        this.toastMessageService.showError(error);
        this.showSkeleton$.next(false);
        this.cd.detectChanges();
      },
    });
  }

  GetAppointmentTypes() {
    this.store
      .select(APPOINTMENT_TYPE_STATE)
      .subscribe((responseData: AppointmentType[]) => {
        if (responseData) {
          this.appointmentCategories = responseData.filter(o=>o.status == Status[Status.Active]);
        } else {
          this.appointmentCategories = [];
        }
      });
  }

  SelectScheduleConfig(config:any)
  {
    this.staffAvailabilityConfigForm.reset();
    this.selectedConfigData = config.value;
    this.newSchedule=false;
    this.SelectedAvailabilityFormControl.setValue(config.value);
    this.WeekDays.forEach((day) => {
      this.staffAvailabilityConfigForm.removeControl('availableIntervals_' + day);
      this.staffAvailabilityConfigForm.removeControl('unavailableIntervals_' + day);
    });

    this.staffAvailabilityConfigForm.clearValidators();
    this.createDynamicFormFields(this.selectedConfigData);
  }

  SelectSchduleType(event:any)
  {
     if(event.value.value == "ongoing") 
     {
      this.onGoingDate= true;
      this.specificDateRange=false;
      this.ongoingDateSelected=false;
      this.specificDateRangeSelected= false;
      this.EndDateFormControl.removeValidators(Validators.required);
     }
     else{
      this.EndDateFormControl.addValidators(Validators.required);
      this.onGoingDate= false;
      this.specificDateRange=true;
      this.ongoingDateSelected=false;
      this.specificDateRangeSelected= false;
     }
  }

  CreateNewSchedule()
  {
    this.showSkeleton$.next(true);
    this.newSchedule=true;
    this.selectedConfigData = {} as StafAvailabilityConfig;
    this.staffAvailabilityConfigForm.reset();
    this.staffAvailabilityConfigDatesForm.reset();
    const formControls = Object.keys(this.staffAvailabilityConfigDatesForm.controls);

    formControls.forEach(controlName => {
      this.staffAvailabilityConfigDatesForm.removeControl(controlName);
    });

    this.WeekDays.forEach((day) => {
      this.staffAvailabilityConfigForm.removeControl('availableIntervals_' + day);
      this.staffAvailabilityConfigForm.removeControl('unavailableIntervals_' + day);
    });
    this.exception_dates_data=[];
    this.createDynamicFormFields(this.selectedConfigData);
    this.showSkeleton$.next(false);
    this.cd.detectChanges();
  }

  createDynamicFormFields(selectedConfigData:StafAvailabilityConfig) {
    if (Object.keys(selectedConfigData).length > 0) {
      let configData = selectedConfigData;
      this.SelectedAvailabilityFormControl.setValue(configData);
      this.StartDateFormControl.setValue(this.timeService.ConvertUTCToLocalDateTime(configData.start_date));
      this.EndDateFormControl.setValue(this.timeService.ConvertUTCToLocalDateTime(configData.end_date));
      this.NameFormControl.setValue(configData.name);
      if(configData.start_date && !this.isDefaultDate(configData.end_date))
      {
        this.SelectedScheduleTypeFormControl.setValue(this.schedules[1]);
        this.ongoingDateSelected = false;
      }
      else{
         this.SelectedScheduleTypeFormControl.setValue(this.schedules[0]);
         this.ongoingDateSelected = true;
      }
      
          let appointmentCategories = this.appointmentCategories.filter((o: { id: number; }) => configData.appointment_catagories.find(appt => appt.appt_type_id == o.id));
          if(configData.is_tour_schedule)
          {
            let appointmentType : AppointmentType ={} as AppointmentType;
            appointmentType.id=0;
            appointmentType.name_primary_language= "Sales tour";
            appointmentType.name_secondary_language= "Sales tour";
            appointmentCategories.push(appointmentType);
          }
          this.SelectedAppointmentCategoryFormControl.setValue(appointmentCategories);
         //this.SelectedAppointmentCategoryFormControl.setValue(this.appointmentCategories.filter((o: { id: number; }) => configData.appointment_catagories.find(appt => appt.appt_type_id == o.id)))

      this.WeekDays.forEach((day: any) => {
        if (configData.type_weekday.find((w) => w.wday == day)) {
          let weekDayData = configData.type_weekday.find((w) => w.wday == day)!;
          this.SelectedDayFormControl(weekDayData.wday.toString()).setValue(true);

          const availableSlots = weekDayData.intervals.filter((o) => o.is_available);
          const unavailableSlots = weekDayData.intervals.filter((o) => !o.is_available);

          if (availableSlots.length > 0) {
            this.staffAvailabilityConfigForm.addControl(
              'availableIntervals_' + day,
              this.fb.array(
                availableSlots.map((interval) => this.createInterval(interval, true)),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] }
              )
            );
          } else {
            this.staffAvailabilityConfigForm.addControl(
              'availableIntervals_' + day,
              this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
            );
          }
          
          if (unavailableSlots.length > 0) {
            this.staffAvailabilityConfigForm.addControl(
              'unavailableIntervals_' + day,
              this.fb.array(
                unavailableSlots.map((interval) =>
                  this.createInterval(interval, true)
                ),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] }
              )
            );
          } else {
            this.staffAvailabilityConfigForm.addControl(
              'unavailableIntervals_' + day,
              this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
            );
          }
        } else {
            this.staffAvailabilityConfigForm.addControl(
              'availableIntervals_' + day,
              this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
            );
            this.staffAvailabilityConfigForm.addControl(
              'unavailableIntervals_' + day,
              this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
            );
        }
        //this.staffAvailabilityConfigForm.get('availableIntervals_'+day)?.addValidators(availabilityOverlapsWithUnavailabilityValidator(this.staffAvailabilityConfigForm.get('unavailableIntervals_'+day)!));
        //this.staffAvailabilityConfigForm.get('unavailableIntervals_'+day)?.addValidators(unavailabilityOverlapsWithAvailabilityValidator(this.staffAvailabilityConfigForm.get('availableIntervals_'+day)!));

      });

      if(configData.type_date && configData.type_date.length > 0)
      {
        this.exception_dates_data = configData.type_date;
      }
      else this.exception_dates_data = [];
    } else {
      this.WeekDays.forEach((day) => {
          this.staffAvailabilityConfigForm.addControl(
            'availableIntervals_' + day,
            this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
          );
          this.staffAvailabilityConfigForm.addControl(
            'unavailableIntervals_' + day,
            this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
          );
          //this.staffAvailabilityConfigForm.get('availableIntervals_'+day)?.addValidators(availabilityOverlapsWithUnavailabilityValidator(this.staffAvailabilityConfigForm.get('unavailableIntervals_'+day)!));
          //this.staffAvailabilityConfigForm.get('unavailableIntervals_'+day)?.addValidators(unavailabilityOverlapsWithAvailabilityValidator(this.staffAvailabilityConfigForm.get('availableIntervals_'+day)!));
      });
      this.staffAvailabilityConfigDatesForm = this.fb.group({
        exception_dates: new UntypedFormControl([], []),
      });
    }
    this.staffAvailabilityConfigForm.updateValueAndValidity();
    this.cd.detectChanges();
  }

  createInterval(interval: Interval, convertToLocal:boolean=false) {
    let startTime:any;
    let endTime:any;
    if(convertToLocal)
    {
      startTime = (interval.From !== "" && interval.From !== "00:00:00") ? this.setFullDate(this.convertTimeStringToLocal(interval.From)) : '';
      endTime = (interval.to !== "" && interval.to !== "00:00:00") ? this.setFullDateForEndDate(this.convertTimeStringToLocal(interval.to)) : '' ;
    }
    else{
      startTime = (interval.From !== "" && interval.From !== "00:00:00") ? this.setFullDate(interval.From) : '';
      endTime = (interval.to !== "" && interval.to !== "00:00:00") ? this.setFullDateForEndDate(interval.to) : '' ;
    }
   
    return this.fb.group({
      startTime: [startTime, [timeSlotsValidator, endNotBeforeStart,startEndTimeRequired]],
      endTime: [endTime, [timeSlotsValidator, endNotBeforeStart,startEndTimeRequired]],
      is_available: [interval.is_available],
      reason_for_unavailability: [interval.reason_for_unavailability]
    });
  }

  createEmptyInterval() {
    const formGroups: FormGroup[] = [];
    formGroups.push(
      this.fb.group({
        startTime: ['', [timeSlotsValidator, endNotBeforeStart,startEndTimeRequired]],
        endTime: ['', [timeSlotsValidator, endNotBeforeStart,startEndTimeRequired]],
        reason_for_unavailability: ['']
      })
    );
    return formGroups;
  }


  addAvailableInterval(weekDay: string) {
    const intervalsArray = this.staffAvailabilityConfigForm.get('availableIntervals_'+weekDay) as FormArray;
    const unavailableIntervalsArray = this.staffAvailabilityConfigForm.get('unavailableIntervals_'+weekDay) as FormArray;
    intervalsArray.push(this.createInterval({ From: '', to: '', is_available: true, reason_for_unavailability: "" }));
    intervalsArray.addValidators(availabilityOverlapsWithUnavailabilityValidator(unavailableIntervalsArray));
  }

  addUnavailableInterval(weekDay: string) {
    const intervalsArray = this.staffAvailabilityConfigForm.get('unavailableIntervals_'+weekDay) as FormArray;
    const availableIntervalsArray = this.staffAvailabilityConfigForm.get('availableIntervals_'+weekDay) as FormArray;
    intervalsArray.push(this.createInterval({ From: '', to: '', is_available: true, reason_for_unavailability: "" }));
    //intervalsArray.addValidators(unavailabilityOverlapsWithAvailabilityValidator(availableIntervalsArray));
  }

  editExceptionDate(exception:TypeDate)
  {
    var exceptionDate = this.timeService.ConvertUTCToLocalDateTime(exception.date);
    this.selectedDate= this.datePipe.transform(exceptionDate, 'dd/MM/yyyy');
    this.selectedDates.push({"date" : this.datePipe.transform(exceptionDate, 'dd/MM/yyyy'),"multiple": false,"dateObject": exception.date});
    this.selectedDateIndex= this.selectedDates.findIndex(o => o.date == this.selectedDate);
    this.staffAvailabilityConfigDatesForm.get('exception_dates')?.value.push(new Date(exceptionDate));
    this.CreateIntervalForDate(this.datePipe.transform(exceptionDate, 'dd/MM/yyyy'),exception);
    this.dateOverride=true;
    this.dateSelected = true;
    this.cd.detectChanges();
  }

  deleteExceptionDate(exception:TypeDate){
    this.exception_dates_data = this.exception_dates_data.filter(o => o.date != exception.date);
    this.cd.detectChanges();
  }

  createIntervalsOnDateSelect(date: any)
  {
    if(this.dateSelected) {
      this.selectedDates.push({"date" : this.datePipe.transform(date, 'dd/MM/yyyy'),"multiple": true, "dateObject": date});
      this.selectedDates[0].multiple= true;
    } 
    else this.selectedDates.push({"date" : this.datePipe.transform(date, 'dd/MM/yyyy'),"multiple": false,"dateObject": date});
    this.selectedDate= this.datePipe.transform(date, 'dd/MM/yyyy');
    this.CreateIntervalForDate(this.datePipe.transform(date, 'dd/MM/yyyy'),null);
    this.dateOverride = true;
    this.dateSelected = true;
    this.cd.detectChanges();
  }

 CreateIntervalForDate(date: any, exceptions_date:TypeDate | null) {
    this.staffAvailabilityConfigDatesForm.addControl(
      'unavailableIntervalsDateReason_' + this.selectedDate, new UntypedFormControl('')
    );
    if(exceptions_date != null)
    {
      const availableSlots = exceptions_date.intervals.filter((o) => o.is_available);
      const unavailableSlots = exceptions_date.intervals.filter((o) => !o.is_available);

      if(availableSlots.length > 0){
        this.staffAvailabilityConfigDatesForm.addControl(
          'availableIntervalsDate_' + date,
          this.fb.array(
            availableSlots.map((interval) =>
              this.createInterval(interval, true)
            ),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] }
          )
        );
      }
      else {
        this.staffAvailabilityConfigDatesForm.addControl(
          'availableIntervalsDate_' +date,
          this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
        );
      }

      if(unavailableSlots.length > 0){
        this.staffAvailabilityConfigDatesForm.addControl(
          'unavailableIntervalsDate_' + date,
          this.fb.array(
            unavailableSlots.map((interval) =>
              this.createInterval(interval,true)
            ),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] }
          )
        );
      }
      else {
        this.staffAvailabilityConfigDatesForm.addControl(
          'unavailableIntervalsDate_' + date,
          this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
        );
      }

      //this.staffAvailabilityConfigDatesForm.get('availableIntervalsDate_'+date)?.addValidators(availabilityOverlapsWithUnavailabilityValidator(this.staffAvailabilityConfigDatesForm.get('unavailableIntervalsDate_'+date)!));
      //this.staffAvailabilityConfigDatesForm.get('unavailableIntervalsDate_'+date)?.addValidators(unavailabilityOverlapsWithAvailabilityValidator(this.staffAvailabilityConfigDatesForm.get('availableIntervalsDate_'+date)!));

      this.staffAvailabilityConfigDatesForm.addControl(
        'unavailableIntervalsDateReason_' + date, new UntypedFormControl(unavailableSlots.length > 0 ? unavailableSlots[0].reason_for_unavailability : '')
      );
      this.staffAvailabilityConfigDatesForm.addControl(
        'is_full_day_unavailable_' +date,new UntypedFormControl(false)
      );
      this.cd.detectChanges();
    }
    else{
      if(this.selectedDates.length > 1) 
      {
        let availableformGroup = this.staffAvailabilityConfigDatesForm.get('availableIntervalsDate_'+this.selectedDates[0].date) as FormArray;
        let unavailableformGroup = this.staffAvailabilityConfigDatesForm.get('unavailableIntervalsDate_'+this.selectedDates[0].date) as FormArray;
        this.staffAvailabilityConfigDatesForm.addControl(
          'availableIntervalsDate_' + date,
          this.fb.array(availableformGroup.controls.map(o => this.fb.group(o.value)),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
        );
        this.staffAvailabilityConfigDatesForm.addControl(
          'unavailableIntervalsDate_' + date,
          this.fb.array(unavailableformGroup.controls.map(o => this.fb.group(o.value)),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
        );
      }
      else{
        this.staffAvailabilityConfigDatesForm.addControl(
          'availableIntervalsDate_' +date,
          this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
        );
        this.staffAvailabilityConfigDatesForm.addControl(
          'unavailableIntervalsDate_' +date,
          this.fb.array(this.createEmptyInterval(),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
        );
      }
      this.staffAvailabilityConfigDatesForm.addControl(
        'is_full_day_unavailable_' +date,new UntypedFormControl(false)
      );
    }
    this.exceptionDatesAvailable[date] = new Array();
    this.exceptionDatesUnAvailable[date] = new Array();
    this.exceptionDatesAvailable[date].push({ starttime: '', endtime: '' });
    this.exceptionDatesUnAvailable[date].push({ starttime: '', endtime: '' });
    this.cd.detectChanges();
  }

  addAvailableIntervalForDate(date1: string) {
    this.selectedDates.forEach(date => {
      const intervalsArray = this.staffAvailabilityConfigDatesForm.get('availableIntervalsDate_'+date.date) as FormArray;
      const unavailableIntervalsArray = this.staffAvailabilityConfigDatesForm.get('unavailableIntervalsDate_'+date.date) as FormArray;
      intervalsArray.push(this.createInterval({ From: '', to: '', is_available: true, reason_for_unavailability: "" }));
      intervalsArray.addValidators(availabilityOverlapsWithUnavailabilityValidator(unavailableIntervalsArray));
      Object.keys(this.exceptionDatesAvailable).forEach((dateObj: any) => {
        if (date.date == dateObj)
          this.exceptionDatesAvailable[date.date].push({ starttime: '', endtime: '' });
      });
    })
  }

  addUnAvailableIntervalForDate(date1: string) {
    this.selectedDates.forEach(date => {
      const intervalsArray = this.staffAvailabilityConfigDatesForm.get('unavailableIntervalsDate_'+date.date) as FormArray;
      const availableIntervalsArray = this.staffAvailabilityConfigDatesForm.get('availableIntervalsDate_'+date.date) as FormArray;
      intervalsArray.push(this.createInterval({ From: '', to: '', is_available: true, reason_for_unavailability: "" }));
      //intervalsArray.addValidators(unavailabilityOverlapsWithAvailabilityValidator(availableIntervalsArray));
      Object.keys(this.exceptionDatesUnAvailable).forEach((dateObj: any) => {
        if (date.date == dateObj)
          this.exceptionDatesUnAvailable[date.date].push({ starttime: '', endtime: '' });
      });
    });
  }

  removeAvailableIntervalDate(date: string, index: number) {
    const intervalsArray = this.staffAvailabilityConfigDatesForm.get('availableIntervalsDate_'+date) as FormArray;
    if(intervalsArray.length > 1)
    {
      intervalsArray.removeAt(index);
      Object.keys(this.exceptionDatesAvailable).forEach((day: any) => {
        this.selectedDates.forEach(d => {
            this.exceptionDatesAvailable[d.date].splice(index, 1);
        })
      });
    }
  }

  removeUnAvailableIntervalDate(date: string, index: number) {
    const intervalsArray = this.staffAvailabilityConfigDatesForm.get('unavailableIntervalsDate_'+date) as FormArray;
    if(intervalsArray.length > 1)
    {
      intervalsArray.removeAt(index);
      Object.keys(this.exceptionDatesUnAvailable).forEach((day: any) => {
        this.selectedDates.forEach(d => {
          this.exceptionDatesUnAvailable[d.date].splice(index, 1);
        })
      });
    }
  }

  removeAvailableInterval(weekDay: string, index: number) {
    const intervalsArray = this.staffAvailabilityConfigForm.get('availableIntervals_'+weekDay) as FormArray;
    if(intervalsArray.length > 1)
    {
      intervalsArray.removeAt(index);
    }
  }

  removeUnAvailableInterval(weekDay: string, index: number) {
    const intervalsArray = this.staffAvailabilityConfigForm.get('unavailableIntervals_'+weekDay) as FormArray;
    if(intervalsArray.length > 1)
    {
      intervalsArray.removeAt(index);
    }
  }

  copyData(fromDay:string) {
    const selectedCheckboxes = Object.keys(this.checkBoxForm.value).filter(
      (day) => this.checkBoxForm.get(day)?.value === true
    );

    let FromDayAvailableformGroup = this.staffAvailabilityConfigForm.get('availableIntervals_'+fromDay) as FormArray; 
    let FromUnavailableformGroup = this.staffAvailabilityConfigForm.get('unavailableIntervals_'+fromDay) as FormArray; 

    selectedCheckboxes.forEach((day) => {
      this.staffAvailabilityConfigForm.get('selectedDay_'+day)?.setValue(true);
      let ToDayAvailableformGroup = this.staffAvailabilityConfigForm.get('availableIntervals_'+day) as FormArray; 
      let ToDayUnavailableformGroup = this.staffAvailabilityConfigForm.get('unavailableIntervals_'+day) as FormArray; 

      ToDayAvailableformGroup.clear();
      ToDayUnavailableformGroup.clear()

      this.staffAvailabilityConfigForm.setControl(
        'availableIntervals_' + day,
        this.fb.array(FromDayAvailableformGroup.controls.map(o => this.fb.group(o.value)),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
      );
      this.staffAvailabilityConfigForm.setControl(
        'unavailableIntervals_' + day,
        this.fb.array(FromUnavailableformGroup.controls.map(o => this.fb.group(o.value)),{ validators: [timeSlotsValidator(),endNotBeforeStart(),startEndTimeRequired()] })
      );
    });
    this.staffAvailabilityConfigForm.updateValueAndValidity();
    this.checkBoxForm.reset();
    this.cd.detectChanges();
  }

  SetOverrideDatesData()
  {
     // Get the form values
     const formValues = this.staffAvailabilityConfigDatesForm.value;
     let exceptionDates= formValues.exception_dates;
     let exceptionDatesData:TypeDate[] =[];
     exceptionDates.forEach((date:any) => {
      let typeDate:TypeDate ={} as TypeDate;
      typeDate.intervals=[];
      let formatedDate= this.selectedDates[this.selectedDates.length -1].date;
      typeDate.date = date;
      if(this.selectedDates.find(o => o.date == date)){
         typeDate.multiple = this.selectedDates.find(o => o.date == date).multiple;
      }
      let availableIntervals = formValues['availableIntervalsDate_'+formatedDate];
      let unavailableIntervals = formValues['unavailableIntervalsDate_'+formatedDate];
      let reason = formValues['unavailableIntervalsDateReason_'+formatedDate];
      let isFullDayUnavailble:boolean = formValues['is_full_day_unavailable_'+formatedDate];
      if(!isFullDayUnavailble)
      {
        if(availableIntervals && availableIntervals.length > 0)
        {
          availableIntervals.forEach((element:any) => {
            if(element.startTime !="" && element.endTime !="")
            {
              let interval:Interval= {} as Interval;
              interval.From = this.getTimeFromDateString(element.startTime);
              interval.to =  this.getTimeFromEndDateString(element.endTime);
              interval.is_available= true;
              interval.reason_for_unavailability="";
              typeDate.intervals.push(interval);
            }
          });
        }
        if(unavailableIntervals && unavailableIntervals.length > 0)
        {
          unavailableIntervals.forEach((element:any) => {
            if(element.startTime !="" && element.endTime !="")
            {
              let interval:Interval= {} as Interval;
              interval.From = this.getTimeFromDateString(element.startTime);
              interval.to =  this.getTimeFromEndDateString(element.endTime);
              interval.is_available= false;
              interval.reason_for_unavailability=reason;
              typeDate.intervals.push(interval);
            }
          });
        }
        exceptionDatesData.push(typeDate);
      }
      else{
        const startTimeDate = new Date(new Date().setHours(0,0,0));
        const endTimeDate = new Date(new Date().setHours(23,59,59));
        let interval:Interval= {} as Interval;
        interval.From = this.getTimeFromDateString(startTimeDate);
        interval.to =  this.getTimeFromEndDateString(endTimeDate);
        interval.is_available= false;
        interval.reason_for_unavailability=reason;
        typeDate.intervals.push(interval);
        exceptionDatesData.push(typeDate);
      }
     });

     if(this.exception_dates_data.length > 0)
     {
      exceptionDatesData.forEach((o, i) => {
        if(this.exception_dates_data.find(d => this.timeService.ConvertUTCToLocalDateTime(d.date).getTime() == new Date(o.date).getTime()))
        {
          const index = this.exception_dates_data.findIndex(d => this.timeService.ConvertUTCToLocalDateTime(d.date).getTime() == new Date(o.date).getTime())
          this.exception_dates_data[index] = o;
        }
        else{
          this.exception_dates_data.push(o);
        }
      });
     }
     else{
      this.exception_dates_data = exceptionDatesData;
     }
     
     this.selectedDate="";
     this.selectedDates=[];
     this.dateOverride=false;
     this.cd.detectChanges();
  }
  
  
  getTimeFromDateString(dateString:any) {
    if(dateString =='') return `00:00:00`;
    const date = this.timeService.ConvertLocalDateTimeToUTCInDateObject(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getTimeFromEndDateString(dateString:any) {
    if(dateString =='') return `00:00:00`;
    const date = this.timeService.ConvertLocalDateTimeToUTCInDateObject(dateString);
    const hours = date.getHours();
    const minutes = date.getMinutes();
    date.setSeconds(-1);
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  setFullDate(timeString: string) {
    const [hours, minutes] = timeString.split(':');
    const currentDate = new Date();
    currentDate.setHours(parseInt(hours));
    currentDate.setMinutes(parseInt(minutes));
    return currentDate;
  }

  setFullDateForEndDate(timeString: string) {
    const [hours, minutes] = timeString.split(':');
    const currentDate = new Date();
    currentDate.setHours(parseInt(hours));
    currentDate.setMinutes(parseInt(minutes));
    currentDate.setSeconds(-1);
    return currentDate;
  }

  convertTimeStringToLocal(timeString: string) {
    // const currentDate = new Date(`1970-01-01T${timeString}Z`);
    const currentDate = this.timeService.ConvertLocalDateTimeToUTCInDateObject(new Date(`1970-01-01`));
    const [hours, minutes] = timeString.split(':');
    currentDate.setHours(parseInt(hours));
    currentDate.setMinutes(parseInt(minutes));
    var localdate =this.timeService.ConvertUTCToLocalDateTime(currentDate);
    const formattedTime = `${localdate.getHours().toString().padStart(2, '0')}:${localdate.getMinutes().toString().padStart(2, '0')}:00`;
    // const formattedTime = `${currentDate.getHours().toString().padStart(2, '0')}:${currentDate.getMinutes().toString().padStart(2, '0')}:00`;

    // const currentDate = this.datePipe.transform(new Date(`1970-01-01T${timeString}Z`), 'yyyy-MM-ddTHH:mm:ss', "UTC"); new Date(`1970-01-01T${timeString}Z`);
    // const hours = currentDate.getHours();
    // const minutes = currentDate.getMinutes();
    // const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  client2LetterName(name: string): string {
    if (name) {
      const nameArray = name.split(' ');
      const newNameArray = [];
      for (let i = 0; i < nameArray.length; i++) {
        if (newNameArray.length >= 2) break;

        if (nameArray[i]) {
          newNameArray.push(nameArray[i]);
        }
      }
      return newNameArray.join(' ');
    } else {
      return '';
    }
  }

  closeOerridePopup(selectedDate:any)
  {
    const [day, month, year] = selectedDate.split('/');
    let date =   new Date(Number(year), Number(month) - 1, Number(day));
    if (Object.keys(this.selectedConfigData).length > 0) {
      this.selectedDate="";
      this.selectedDates=[];
      this.staffAvailabilityConfigDatesForm.get('exception_dates')?.setValue([]);
      this.dateOverride = false;
    }
    else{
      const availableIntervalsArray = this.staffAvailabilityConfigDatesForm.get('availableIntervalsDate_'+selectedDate) as FormArray;
      if(availableIntervalsArray.controls && availableIntervalsArray.controls .length > 0)
      {
        availableIntervalsArray.controls.forEach((element:any) => {
          element.controls["endTime"].setValue(null);
          element.controls["startTime"].setValue(null);
        });
      }

      const unIntervalsArray = this.staffAvailabilityConfigDatesForm.get('unavailableIntervalsDate_'+selectedDate) as FormArray;
      if(unIntervalsArray.controls && unIntervalsArray.controls.length > 0)
      {
        unIntervalsArray.controls.forEach((element:any) => {
          element.controls["endTime"].setValue(null);
          element.controls["startTime"].setValue(null);
        });
      }
      this.staffAvailabilityConfigDatesForm.get('exception_dates')?.setValue([]);
      this.exception_dates_data = this.exception_dates_data.filter(o =>o.date != date.toString() );
      this.selectedDate="";
      this.selectedDates=[];
      this.dateOverride = false;
      this.cd.detectChanges();
    }
  }

  getAvailableintervalsForDate(data:any, date:any)
  {
    return data.find((o: { key: any; }) => o.key == date).value;
  }

  SelectedDayFormControl(day: string): UntypedFormControl {
    return this.staffAvailabilityConfigForm.get(
      'selectedDay_' + day
    )! as UntypedFormControl;
  }

  SelectedDayValue(day: string) {
    return this.staffAvailabilityConfigForm.get('selectedDay_' + day)!.value;
  }

  GetWeekDayIntervalsFormControl(day: string): UntypedFormArray {
    return this.staffAvailabilityConfigForm.get(
      'selectedDayIntervals_' + day
    ) as UntypedFormArray;
  }

  GetAvailableIntervalsFormControl(day: string): UntypedFormArray {
    return this.staffAvailabilityConfigForm.get(
      'availableIntervals_' + day
    ) as UntypedFormArray;
  }

  GetUnAvailableIntervalsFormControl(day: string): UntypedFormArray {
    return this.staffAvailabilityConfigForm.get(
      'unavailableIntervals_' + day
    ) as UntypedFormArray;
  }

  getAvailableIntervals(intervals:Interval[])
  {
    return intervals.filter(o => o.is_available);
  }

  getUnAvailableIntervals(intervals:Interval[])
  {
    return intervals.filter(o => o.is_available == false);
  }

  getAvailableIntervalsForOverrideDates(intervals:Interval[])
  {
    let filterIntervals = intervals.filter(o => o.From !== "00:00:00" || o.to !== "00:00:00");
    return filterIntervals.filter(o => o.is_available);
  }

  getUnAvailableIntervalsForOverrideDates(intervals:Interval[])
  {
    //return intervals.filter(o => o.is_available == false);
    let filterIntervals = intervals.filter(o => o.From !== "00:00:00" || o.to !== "00:00:00");
    return filterIntervals.filter(o => o.is_available == false);
  }

  parseTimeStringToDateTime(timeString: string): Date {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    const date = new Date(1970, 0, 1, hours, minutes, seconds);
    return date;
  }

  CloseSpecificDateRange()
  {
    if(!this.specificDateRangeSelected){
      this.staffAvailabilityConfigForm.get('schedule_date_range')?.setValue(null);
      this.staffAvailabilityConfigForm.get('schedule_type')?.setValue(null);
    }
    this.specificDateRange = false; 
  }

  CloseOngoingDateRange()
  {
    if(!this.ongoingDateSelected){
      this.staffAvailabilityConfigForm.get('ongoing_date')?.setValue(null);
      this.staffAvailabilityConfigForm.get('schedule_type')?.setValue(null);
    }
    this.onGoingDate = false; 
  }

  
  hasDuplicatesValue(array: any[]): boolean {
    return new Set(array).size !== array.length;
  }
  
  hasOverlaps(timeSlots: any[]): boolean {
    for (let i = 0; i < timeSlots.length; i++) {
      for (let j = i + 1; j < timeSlots.length; j++) {
        const a = timeSlots[i];
        const b = timeSlots[j];
        if (a.start <= b.end && a.end >= b.start) {
          return true;
        }
      }
    }
    return false;
  }

  setFullDatUnAvailable(event:any, selectedDay:string)
  {
    let availableformGroup = this.staffAvailabilityConfigDatesForm.get('availableIntervalsDate_'+selectedDay) as FormArray;
    let unavailableformGroup = this.staffAvailabilityConfigDatesForm.get('unavailableIntervalsDate_'+selectedDay) as FormArray;
    if(event.checked)
    {
      availableformGroup.controls.map(o =>  o.disable());
      unavailableformGroup.controls.map(o =>  o.disable());
      //this.staffAvailabilityConfigDatesForm.get('is_full_day_unavailable_'+selectedDay)?.setValue(true);
    }
    else{
      availableformGroup.controls.map(o =>  o.enable());
      unavailableformGroup.controls.map(o =>  o.enable());
      //this.staffAvailabilityConfigDatesForm.get('is_full_day_unavailable_'+selectedDay)?.setValue(false);
    }
  }
  
  @ViewChild('calendar') private calendar: any;
  onCustomDateSelect() {
    const timePeriodValue = this.staffAvailabilityConfigForm.get('schedule_date_range')?.value;
    if (timePeriodValue && timePeriodValue[1]) {
      this.calendar.overlayVisible = false;
      this.StartDateFormControl.setValue(timePeriodValue[0]);
      this.EndDateFormControl.setValue(timePeriodValue[1]);
      this.specificDateRangeSelected=true;
      this.ongoingDateSelected = false;
    }
  }

  OnGoingDateSelect()
  {
    const ongoingDate = this.staffAvailabilityConfigForm.get('ongoing_date')?.value;
    this.StartDateFormControl.setValue(this.staffAvailabilityConfigForm.get('ongoing_date')?.value);
    this.EndDateFormControl.setValue(null);
    this.ongoingDateSelected = true;
    this.specificDateRangeSelected=false;
  }

  GetSelectedDate(value:string)
  {
    if(value == "ongoing") 
    {
     return `${this.datePipe.transform(this.StartDateFormControl.value, 'dd/MM/yyyy')}`
    }
    else{
      return `${this.datePipe.transform(this.StartDateFormControl.value, 'dd/MM/yyyy')} - ${this.datePipe.transform(this.EndDateFormControl.value, 'dd/MM/yyyy')}`
    }
  }

  SaveData()
  {
   
    if(this.staffAvailabilityConfigForm.valid)
    {
      this.isSubmitting= true;
      const formValues = this.staffAvailabilityConfigForm.value;
      let payload : CreateStaffAvaialbilityConfigRequest= {} as CreateStaffAvaialbilityConfigRequest;
      payload.name = formValues["name"];
      payload.start_date = this.timeService.ConvertLocalDateTimeToUTC(formValues["start_date"]);
      payload.end_date = this.ongoingDateSelected ? null : this.timeService.ConvertLocalDateTimeToUTC(formValues["end_date"]);
      payload.appointment_catagories = [] as AppointmentCatagory[];
      payload.type_date = [] as TypeDate[];
      payload.type_weekday = [] as TypeWeekday[];
  
      let apppintmentCategories = formValues["appointment_catagories"];
      if(apppintmentCategories && apppintmentCategories.length > 0) {
        apppintmentCategories.forEach((appt:any) => {
          if(appt.id > 0) {
            payload.appointment_catagories.push({appt_type_id:appt.id, max_appointments_per_day:0});
          }
        });
      }

      if(apppintmentCategories.find((o: { id: number; }) => o.id == 0))
      {
        payload.is_tour_schedule = true;
      }
      else{
        payload.is_tour_schedule=false;
      }
      
      this.WeekDays.forEach(day => {
        if(formValues["selectedDay_"+day])
        {
          let weekDays:TypeWeekday ={} as TypeWeekday;
          weekDays.wday= day;
          weekDays.intervals=[] as Interval[];
          let availableIntervals = formValues["availableIntervals_"+day];
          let unavailableIntervals = formValues["unavailableIntervals_"+day];
          const filteredAvailableIntervals = availableIntervals.filter((entry: { startTime: string; endTime: string; }) => entry.startTime !== "" || entry.endTime !== "");
          const filteredUnavailableIntervals = unavailableIntervals.filter((entry: { startTime: string; endTime: string; }) => entry.startTime !== "" || entry.endTime !== "");
        filteredAvailableIntervals.forEach((i:any) => {
            weekDays.intervals.push({
              From: this.getTimeFromDateString(i.startTime),
              to:  this.getTimeFromEndDateString(i.endTime),
              is_available: true,
              reason_for_unavailability: ''
            })
          });
          filteredUnavailableIntervals.forEach((i:any) => {
            weekDays.intervals.push({
              From: this.getTimeFromDateString(i.startTime),
              to:  this.getTimeFromEndDateString(i.endTime),
              is_available: false,
              reason_for_unavailability: i.reason_for_unavailability
            })
          });
          payload.type_weekday.push(weekDays);
        }
      });
  
      if(this.exception_dates_data.length > 0)
      {
        payload.type_date = this.exception_dates_data;
      }

      let service:any;
      if(this.newSchedule)
      {
        service = this.staffAvailabilityService.CreateStaffAvailability(this.tenantId,this.staffId, payload);
      }
      else{
        service = this.staffAvailabilityService.EditStaffAvailability(this.tenantId,this.staffId, this.selectedConfigData.group_id, payload);
      }
      service .subscribe({
        next: (response: any) => {
          if(this.newSchedule)
          {
            this.translate.get('STAFF_SCHEDULE.MSG.SUCCESS_MSG')
            .subscribe((translation) => {
             this.toastMessageService.showSuccess(translation);
            });
            this.createscheduleGroupId = response.id;
            this.GetAllData();
            this.isSubmitting= false;
          }
          else{
            this.translate.get('STAFF_SCHEDULE.MSG.UPDATE_MSG')
            .subscribe((translation) => {
             this.toastMessageService.showSuccess(translation);
            });
            this.isSubmitting= false;
          }
          
          this.cd.detectChanges();
        },
        error: (error:any) => {
          this.isSubmitting=false;
          this.toastMessageService.showError(error);
          this.cd.detectChanges();
        },
      });

    }
    else {
      Object.keys(this.staffAvailabilityConfigForm.controls).forEach((field) => {
        const control = this.staffAvailabilityConfigForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      const firstElementWithError: Element | null = document.querySelector('.ng-invalid');
      if (firstElementWithError) firstElementWithError.scrollIntoView({ behavior: 'smooth' });
    }
    
  }



  getExceptionDates() {
    if (this.selectedDates.length === 0) {
      return '';
    }
  
    // Group dates by month
    const datesByMonth:any = {};
  
    this.selectedDates.forEach(dateInfo => {
      const monthYear = this.datePipe.transform(dateInfo.dateObject, 'MMMM yyyy')!.toString();
      if (!datesByMonth[monthYear]) {
        datesByMonth[monthYear] = [];
      }
      datesByMonth[monthYear].push(new Date(dateInfo.dateObject).getDate());
    });
  
    // Generate the date info string
    let dateInfo = '';
    for (const monthYear in datesByMonth) {
      if (datesByMonth.hasOwnProperty(monthYear)) {
        const dates = datesByMonth[monthYear];
        const dateStr = this.formatDates(dates);
        dateInfo += `${dateStr} ${monthYear}, `;
      }
    }
  
    return dateInfo.slice(0, -2); // Remove the trailing comma and space
  }
  
  formatDates(dates: number[]): string {
    if (dates.length === 1) {
      return dates[0].toString();
    } else {
      return dates.slice(0, -1).join(', ') + ` and ${dates.slice(-1)}`;
    }
  }

  isDefaultDate(dateString: string): boolean {
    const defaultDateString: string = "0001-01-01T00:00:00";
    const providedDate: Date = new Date(dateString);
    const defaultDate: Date = new Date(defaultDateString);
  
    return providedDate.getTime() === defaultDate.getTime();
  }

  getFormError()
  {
    this.getAllErrors(this.staffAvailabilityConfigForm);
  }

  hasEndTimeError(slot:any)
  {
    return slot.controls['endTime'].hasError('overlaps') || slot.controls['endTime'].hasError('endBeforeStart') || slot.controls['endTime'].hasError('unavailabilityOverlaps') || slot.controls['endTime'].hasError('availabilityOverlaps') || slot.controls['endTime'].hasError('startEndRequired') || slot.controls['endTime'].errors;
  }

  hasStartTimeError(slot:any)
  {
    return slot.controls['startTime'].hasError('overlaps') || slot.controls['startTime'].hasError('endBeforeStart') || slot.controls['startTime'].hasError('unavailabilityOverlaps') || slot.controls['startTime'].hasError('availabilityOverlaps') || slot.controls['startTime'].hasError('startEndRequired') || slot.controls['startTime'].errors;
  }

  hasError(slot:any)
  {
    return slot.hasError('overlaps') || slot.hasError('endBeforeStart') || slot.hasError('unavailabilityOverlaps') || slot.hasError('availabilityOverlaps') || slot.hasError('startEndRequired') || slot.errors;
  }

  getAllErrors(control: AbstractControl): ValidationErrors | null {
    if (control instanceof FormGroup || control instanceof FormArray) {
      const errors: ValidationErrors = {};
  
      const controlObject = control.controls as AbstractControl[];
      for (const controlName in controlObject) {
        if (controlObject.hasOwnProperty(controlName)) {
          const nestedControl = controlObject[controlName] as AbstractControl;
          const nestedErrors = this.getAllErrors(nestedControl);
          if (nestedErrors) {
            errors[controlName] = nestedErrors;
          }
        }
      }
  
      return Object.keys(errors).length > 0 ? errors : null;
    } else {
      return control.errors;
    }
  }

  getSelectedDayValue(day:string)
  {
    return this.staffAvailabilityConfigForm.get('selectedDay_'+day)!.value;
  }

  getAvailableIntervalsFormControl(day:string):FormArray
  {
    return this.staffAvailabilityConfigForm.get('availableIntervals_'+day) as FormArray;
  }

  getUnAvailableIntervalsFormControl(day:string):FormArray
  {
    return this.staffAvailabilityConfigForm.get('unavailableIntervals_'+day) as FormArray;
  }

  gobackTopage()
  {
    this.routeStateService.redirectToSavedRoute();
  }

  get SelectedAvailabilityFormControl(): UntypedFormControl {
    return this.staffAvailabilityConfigForm.get(
      'staff_availability_config'
    )! as UntypedFormControl;
  }


  get NameFormControl(): UntypedFormControl {
    return this.staffAvailabilityConfigForm.get('name')! as UntypedFormControl;
  }

  get SelectedAppointmentCategoryFormControl(): UntypedFormControl {
    return this.staffAvailabilityConfigForm.get(
      'appointment_catagories'
    )! as UntypedFormControl;
  }

  get SelectedScheduleTypeFormControl(): UntypedFormControl {
    return this.staffAvailabilityConfigForm.get(
      'schedule_type'
    )! as UntypedFormControl;
  }

  get StartDateFormControl(): UntypedFormControl {
    return this.staffAvailabilityConfigForm.get('start_date')! as UntypedFormControl;
  }

  get EndDateFormControl(): UntypedFormControl {
    return this.staffAvailabilityConfigForm.get('end_date')! as UntypedFormControl;
  }

  get showSkeleton():boolean
  {
    return this.showSkeleton$.getValue();
  }

  getFormControlByName(controlName:string):UntypedFormControl
  {
    return this.staffAvailabilityConfigDatesForm.get(controlName) as UntypedFormControl
  }
  

}

const routes: Routes = [
  {
    path: ':id',
    component: StaffAvailabilityComponent,
    canActivate: [AuthguardService],
    resolve: { data: TenantResolverService },
    data: {
      breadcrumb: 'STAFF_AVAILABILITY',
      claim: '',
      title: 'Admin - Staff Availability',
    },
  },
];

interface ShowHideControl {
  name: string;
  value: boolean;
}
